import { createAsyncThunk } from '@reduxjs/toolkit';
import * as ReportService from 'ReportsModule/services';
import { AppStateType } from 'reducers';
import * as Types from 'ReportsModule/types';

export const fetchSuperAdmins = createAsyncThunk<
  Types.FetchSuperAdminsSuccessResponse,
  Types.FetchSuperAdminsParams
>('fetchSuperAdmins', async ({ meta = {}, ...params }, { getState, rejectWithValue }) => {
  const { onFailure, onSuccess } = meta;
  try {
    const {
      authReducer: { user },
    } = getState() as AppStateType;
    const auth_token = user?.auth_token;

    const response = await ReportService.getSuperAdmins({}, auth_token);
    if (onSuccess) {
      onSuccess({ response: response.data as Types.FetchSuperAdminsSuccessResponse });
    }

    return response.data as Types.FetchSuperAdminsSuccessResponse;
  } catch (error) {
    if (onFailure) {
      onFailure({ error });
    }
    return rejectWithValue(error);
  }
});
